var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogsPageIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "white",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke-linejoin:round;stroke-width:1.5px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 32,
    y1: 2,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 20,
    y1: 6,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 32,
    y1: 14,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 20,
    y1: 18,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 32,
    y1: 26,
    y2: 26
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 10,
    x2: 20,
    y1: 30,
    y2: 30
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4,
    cy: 4,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4,
    cy: 16,
    r: 3
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 4,
    cy: 28,
    r: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsPageIcon);
export default __webpack_public_path__ + "static/media/logs-page-icon.56f67144b9b5640482059d938dec1b9f.svg";
export { ForwardRef as ReactComponent };